import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const waiverCategoryMutations: UpdatesConfig['Mutation'] = {
  waiverCategoryCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverCategories', cache);
  },
  waiverCategoryUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['waiverCategories', 'waiverCategoryUsers'], cache);
  },
  waiverCategoryUserUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(['waiverCategoryUsers', 'waiverCategories'], cache);
  },
};

export default waiverCategoryMutations;
